import { authentication } from '@ecosystem/newron-client-lib';
import Base64 from 'base-64';

export const getTokenIssuedAt = async (): Promise<number | null> => {
  const token = await authentication.getAccessToken();
  if (!token) {
    return Promise.resolve(null);
  }
  const parsedToken = JSON.parse(Base64.decode(token.split('.')[1]));
  return parsedToken['iat'] || null;
};
